import { OUR_MISSION } from "@/data/content";

export default function OurMission() {
  return (
    <section data-testid="our-mission" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-8 text-center">
        <span className="overline">Our Mission</span>
        <div className="mt-5 flex justify-center">
          <span className="gold-divider" />
        </div>
        <p className="mt-8 font-serif text-2xl md:text-[32px] leading-snug text-[color:var(--maqam-navy)]">
          {OUR_MISSION}
        </p>
      </div>
    </section>
  );
}
